// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "Notifications" + "." + "7f3384ec" + ".chunk.css";
};